import clsx from 'clsx';

import { Draggable, Droppable } from '@atom/components/common/dragAndDrop';
import { DashboardCard } from '@atom/types/dashboard';

import DashboardCardContainer from './DashboardCardContainer';

import classes from './dashboard.module.css';

type ColumnSize = 'large' | 'small';

const colSizeClass: Record<ColumnSize, string> = {
  large: classes['col-large'],
  small: classes['col-small'],
};

interface Props {
  cards: DashboardCard[];
  size: ColumnSize;
}

const DashboardColumn = ({ cards, size }: Props) => {
  return (
    <div className={clsx(classes.col, colSizeClass[size])}>
      <Droppable droppableId={`col-${size}`}>
        {cards.map((card, idx) => (
          <Draggable
            key={card.id}
            draggableId={card.id}
            index={idx}
            isDragStyleDisabled
          >
            <DashboardCardContainer card={card} />
          </Draggable>
        ))}
      </Droppable>
    </div>
  );
};

export default DashboardColumn;
